import styled from "styled-components";

export const SiteLink = styled.a`
  color: ${(p) => p.color || "var(--task-link-color)"};
  text-decoration: none;
  cursor: pointer;
  font-weight: 400;
  font-size: ${(p) => (p.fontSize ? `${p.fontSize}px` : "14px")};
`;
